function throttleWithTrailing(fn, wait) {
  let lastExec = 0;
  let timer = null;
  return function(...args) {
    const now = Date.now();
    const sinceLast = now - lastExec;
    const context = this;

    const exec = () => {
      lastExec = Date.now();
      timer = null;
      fn.apply(context, args);
    };

    if (sinceLast >= wait) {
      // Leading call
      exec();
    } else if (!timer) {
      // Schedule trailing call
      timer = setTimeout(exec, wait - sinceLast);
    }
  };
}

// Initschleife:
const updateProgressThrottled = throttleWithTrailing(updateProgress, 2000);

// Konfiguration (Cent)
const GIFT1_TH = 4000;  // Geschenk 1 ab 40 €
const FREE_TH  = 5000;  // Gratis Versand ab 50 €
const GIFT2_TH = 6500;  // Geschenk 2 ab 80 €
const FULL_TH  = 10000; // Balken voll bei 100 €

// Einfaches Ein-/Ausschalten der Aktionen:
const GIFT1_ENABLED = false;
const FREE_ENABLED  = true;
const GIFT2_ENABLED = false;

// SKUs, die nicht zählen sollen / Modul ausblenden
const SPECIAL_SKUS = ['801400', '858500','863800'];

async function updateProgress() {
  try {
    const cart   = await fetch('/cart.js', { cache: 'no-cache' }).then(r => r.json());
    const module = document.getElementById('free-shipping-module');
    if (!module) return;
    // Marker nur beim ersten Lauf initialisieren
    if (!module.dataset.markersInit) {
      const gift1Marker = module.querySelector('.marker.gift1');
      const freeMarker  = module.querySelector('.marker.free');
      const gift2Marker = module.querySelector('.marker.gift2');

      if (GIFT1_ENABLED && gift1Marker) gift1Marker.style.display = 'flex';
      if (FREE_ENABLED  && freeMarker)  freeMarker.style.display  = 'flex'; // falls du den auch mal ausblenden willst
      if (GIFT2_ENABLED && gift2Marker) gift2Marker.style.display = 'flex';

      module.dataset.markersInit = 'true';
    }
    // ADVK im Warenkorb? → Modul ausblenden
    const hasSpecialSku = cart.items.some(item => SPECIAL_SKUS.includes(item.sku));
    if (hasSpecialSku) {
      module.style.display = 'none';
      return;
    }
    module.style.display = '';

    // Warenkorb-Wert ohne SPECIAL_SKUS
    const total = cart.items
      .filter(item => !SPECIAL_SKUS.includes(item.sku))
      .reduce((sum, item) => sum + item.line_price, 0);

    const textEl = document.getElementById('shipping-progress-text');
    const fillEl = document.getElementById('progress-bar-fill');

    // Fortschrittsbalken (voll bei 100 €)
    const pct = Math.min(100, (total / FULL_TH) * 100);
    fillEl.style.width = `${pct}%`;

    // Marker ggf. ausblenden
    module.classList.toggle('gift1-hidden', !GIFT1_ENABLED);
    module.classList.toggle('free-hidden',  !FREE_ENABLED);
    module.classList.toggle('gift2-hidden', !GIFT2_ENABLED);

    // Restbeträge
    const remainingG1 = GIFT1_TH - total;
    const remainingF  = FREE_TH  - total;
    const remainingG2 = GIFT2_TH - total;

    // ---------- Textlogik ----------

    // Geschenk 2 erreicht
    if (GIFT2_ENABLED && total >= GIFT2_TH) {
      if (FREE_ENABLED) {
        if (GIFT1_ENABLED) {
          textEl.textContent = 'Yay! Du hast kostenlosen Versand und Geschenk 1 & 2! 🎉';
        } else {
          textEl.textContent = 'Yay! Du hast kostenlosen Versand und ein Geschenk! 🎉';
        }
      } else {
        textEl.textContent = 'Yay! Du hast Geschenk 1 & 2! 🎉';
      }
      return;
    }

    // Geschenk 2 noch nicht erreicht, aber Gratis Versand schon
    if (FREE_ENABLED && total >= FREE_TH) {
      if (GIFT2_ENABLED) {
        const amt = (remainingG2 / 100).toFixed(2).replace('.', ',');
        if (GIFT1_ENABLED) {
          textEl.textContent = `Kostenloser Versand ✅ – nur noch ${amt} € bis zu deinem 2. Geschenk! 🎁`;
        } else {
          textEl.textContent = `Kostenloser Versand ✅ – nur noch ${amt} € bis zu deinem Geschenk! 🎁`;
        }
      } else {
        textEl.textContent = 'Yay! Du hast kostenlosen Versand!';
      }
      return;
    }

    // Gratis Versand noch nicht erreicht, aber Geschenk 1 schon
    if (GIFT1_ENABLED && total >= GIFT1_TH) {
      if (FREE_ENABLED) {
        const amt = (remainingF / 100).toFixed(2).replace('.', ',');
        textEl.textContent = `Geschenk 1 ✅ – nur noch ${amt} € bis zum kostenlosen Versand!`;
      } else {
        textEl.textContent = 'Geschenk 1 ✅ – weiter so!';
      }
      return;
    }

    // Noch nichts erreicht → nächstes Ziel je nach Konfiguration
    if (GIFT1_ENABLED && remainingG1 > 0) {
      const amt = (remainingG1 / 100).toFixed(2).replace('.', ',');
      textEl.textContent = `Noch ${amt} € bis zu deinem ersten Geschenk! 🎁`;
      return;
    }

    if (FREE_ENABLED && remainingF > 0) {
      const amt = (remainingF / 100).toFixed(2).replace('.', ',');
      textEl.textContent = `Noch ${amt} € bis zum kostenlosen Versand!`;
      return;
    }

    // Fallback (falls alles deaktiviert o.ä.)
    textEl.textContent = 'Weiter einkaufen und Vorteile sichern ✨';

  } catch (e) {
    console.error('Free-shipping update failed', e);
  }
}

function initFreeShipping() {

  updateProgressThrottled();

  // Events – auf document hören (dort dispatcht das Theme 'eurus:cart:items-changed')
  document.addEventListener('cart:updated',     updateProgressThrottled);
  document.addEventListener('eurus:cart:items-changed', updateProgressThrottled);

  // MutationObserver
  const drawer = document.getElementById('CartDrawer') || document.getElementById('update-cart');
  if (drawer) {
    new MutationObserver(updateProgressThrottled)
      .observe(drawer, { childList: true, subtree: true });
  }

  // Fallback-Polling alle 3s (fängt Edge-Cases ab)
  setInterval(updateProgress, 3000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFreeShipping);
} else {
  initFreeShipping();
}